import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_ORDER_HISTORY: MijnRoute = {
    path: ':id/order-history',
    navigationEvent: 'toOrderHistory',
    regex: /^\/beleggen\/[^/]+\/order-history$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/order-history'
};
